export const normalizeIndexPagePath = (url: string): string => (url === 'home' ? '' : url);
